import React from 'react';
import { Grid, Container, Box, Typography } from "@material-ui/core";
import { useNavigate } from 'react-router-dom';
import { useStyles } from "./AIAStyle";

const AIA = ({ data, imgUrl, imgCaption }) => {
  const classes = useStyles();
  const API_BASE_URL = 'https://jtimes.zuddo.biz/main/api/getimage'+imgUrl;
  const navigate = useNavigate();

  const handleArticleClick = () => {
    if (data?.title) {
      navigate(`/article/${data.id}`);
    } else if (data?.url) {
      navigate(`/article/${data.url}`);
    }
  };

  return (
    <Box className={classes.sectionContainer} onClick={handleArticleClick} style={{ cursor: 'pointer' }}>
      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={4}>
          <Grid item md={4} xs={12} className={classes.mainArticle}>
            <Box className={classes.articleCard}>
              <Typography variant="h3" component="h2" className={classes.mainTitle}>
                {data?.title}
              </Typography>
              <Typography variant="body1" component="p" className={classes.mainAbstract}>
                {data?.abstract}
              </Typography>
              {data?.byline && (
                <Typography variant="caption" component="p" className={classes.byline}>
                  {data.byline}
                </Typography>
              )}
              {data?.section && (
                <Typography variant="subtitle2" component="p" className={classes.section}>
                  Section: {data.section}
                </Typography>
              )}
              {data?.created_at && (
                <Typography variant="caption" component="p" className={classes.date}>
                  {new Date(data.created_at).toLocaleString()}
                </Typography>
              )}
            </Box>
          </Grid>
          
          <Grid item md={4} xs={12} className={classes.imageSection}>
            <Box className={classes.imageWrapper}>
              {imgUrl && (
                <img 
                  alt={data?.title || "Featured news"} 
                  className={classes.image} 
                  src={API_BASE_URL} 
                />
              )}
              {imgCaption && (
                <Typography variant="caption" component="p" className={classes.imageCaption}>
                  {imgCaption}
                </Typography>
              )}
            </Box>
          </Grid>
          
          <Grid item md={4} xs={12}>
            <Box className={classes.secondaryArticles}>
              <Typography variant="body2" component="p" className={classes.content}>
          
                <div dangerouslySetInnerHTML={{ __html: data.content }} />
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AIA;